<!--
Copyright (c) 2011-present Qualiteam software Ltd. All rights reserved.
See https://www.x-cart.com/license-agreement.html for license details.
-->

<template>
  <div>
    <h1
      align="center"
      class="error-message"
    >
      <i18n path="access-denied.title"/>
    </h1>
    <p align="center">
      <i18n path="access-denied.text" />
    </p>
  </div>
</template>

<script>
export default {
  name: 'PageAccessDenied',
  components: {},
};
</script>



// WEBPACK FOOTER //
// src/components/page/PageAccessDenied.vue